import React, { useState, useEffect } from "react";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";

const PlaceComponent = ({ value, onChange, field, label, error, disabled = false }) => {
  const [address, setAddress] = useState(value || "");

  useEffect(() => {
    setAddress(value || "");
  }, [value]);

  const handleSelect = async (address) => {
    try {
      // Get detailed place information including zip code
      const results = await geocodeByAddress(address);
      if (results && results.length > 0) {
        const place = results[0];
        const addressComponents = place.address_components;
        
        // Extract components
        const streetNumber = addressComponents.find(c => c.types.includes("street_number"))?.long_name || "";
        const route = addressComponents.find(c => c.types.includes("route"))?.long_name || "";
        const city = addressComponents.find(c => c.types.includes("locality"))?.long_name || "";
        const state = addressComponents.find(c => c.types.includes("administrative_area_level_1"))?.short_name || "";
        const country = addressComponents.find(c => c.types.includes("country"))?.short_name || "";
        const postalCode = addressComponents.find(c => c.types.includes("postal_code"))?.long_name || "";
        
        // Build complete address with zip code
        let completeAddress = "";
        if (streetNumber && route) {
          completeAddress = `${streetNumber} ${route}`;
        } else if (route) {
          completeAddress = route;
        }
        
        if (city) completeAddress += completeAddress ? `, ${city}` : city;
        if (state) completeAddress += completeAddress ? `, ${state}` : state;
        if (postalCode) completeAddress += completeAddress ? ` ${postalCode}` : postalCode;
        if (country) completeAddress += completeAddress ? `, ${country}` : country;
        
        // Use complete address with zip code or fall back to original
        const finalAddress = completeAddress || address;
        setAddress(finalAddress);
        onChange(field, finalAddress);
      } else {
        setAddress(address);
        onChange(field, address);
      }
    } catch (error) {
      console.error("Error geocoding address:", error);
      // Fall back to original address if geocoding fails
      setAddress(address);
      onChange(field, address);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const input = document.querySelector(".pac-target-input");
      if (input) {
        input.setAttribute("placeholder", "");
  
        const observer = new MutationObserver(() => {
          input.setAttribute("placeholder", "");
        });
        observer.observe(input, {
          attributes: true,
          attributeFilter: ["placeholder"],
        });
  
        clearInterval(interval);
      }
    }, 100);
  
    return () => clearInterval(interval);
  }, []);
  

  return (
    <div className="place-wrapper">
      <label className="form-label">{label}<span className="text-danger">*</span></label>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
        debounce={300}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="autocomplete-root">
            <input
              {...getInputProps({
                placeholder: "",
                className: "form-control",
                disabled: disabled
              })}
            />

            {(loading || suggestions.length > 0) && (
                <div className="autocomplete-dropdown">
                {loading && <div className="suggestion-item">Loading...</div>}

                {suggestions.map((suggestion) => {
                    const className = suggestion.active
                    ? "suggestion-item active"
                    : "suggestion-item";
                    return (
                    <div
                        {...getSuggestionItemProps(suggestion, {
                        className,
                        })}
                        key={suggestion.placeId}
                    >
                        {suggestion.description}
                    </div>
                    );
                })}
                </div>
             )}     
            {error && <div className="text-danger mt-1">{error}</div>}
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
};

export default PlaceComponent;